import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './assets/site/img/GeoSphere-Tethys-Logo-Header.svg'
import _imports_1 from './assets/site/img/CoreTrustSeal-Logo-Footer.svg'
import _imports_2 from './assets/site/img/Re3data-Logo-Footer.svg'
import _imports_3 from './assets/site/img/BASE-Logo-Footer.svg'
import _imports_4 from './assets/site/img/OpenAIRE-Logo-Footer.svg'
import _imports_5 from './assets/site/img/GeoSphere-Tethys-Logo-Footer.svg'
import _imports_6 from './assets/site/img/GSA_LogoMitZusatz_NegativAufMidnightGreen_RGB_XXS.svg'
import _imports_7 from './assets/site/img/instagram.svg'
import _imports_8 from './assets/site/img/x-twitter.svg'
import _imports_9 from './assets/site/img/youtube.svg'
import _imports_10 from './assets/site/img/facebook.svg'
import _imports_11 from './assets/site/img/linkedin.svg'
import _imports_12 from './assets/site/img/flickr.svg'


const _hoisted_1 = {
  class: "flex justify-center items-center h-32 font-bold text-sm border-b border-gray-200 bg-white py-3",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "hidden md:flex w-[20vw] lg:w-[18vw] 2xl:w-[16vw] items-start justify-left pt-10 space-x-0 lg:space-x-1 2xl:space-x-3 3xl:space-x-5" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "text-xs lg:text-sm 2xl:text-md font-bold" }
const _hoisted_8 = { class: "absolute mt-1 bg-white border border-gray-200 shadow-lg rounded-md z-10" }
const _hoisted_9 = { class: "text-xs lg:text-sm text-gray-800" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "md:hidden w-full bg-white shadow-md z-50"
}
const _hoisted_12 = { class: "flex justify-between items-center px-4 py-3 border-t border-gray-400" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "text-xs lg:text-sm font-bold" }
const _hoisted_16 = { class: "absolute mt-1 ml-2 bg-white border border-gray-200 shadow-lg rounded-md z-10" }
const _hoisted_17 = { class: "text-sm text-gray-800" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex flex-wrap sm:h-[660px] xl:h-[700px] 2xl:h-[900px] text-sm sm:text-xs 2xl:text-sm" }
const _hoisted_20 = { class: "w-full flex flex-wrap bg-tethys-6 h-2/3" }
const _hoisted_21 = { class: "grid grid-cols-2 gap-4 sm:flex sm:flex-wrap sm:gap-0 w-4/6 h-1/3 mx-auto justify-evenly font-bold text-center text-gray-50 text-opacity-40" }
const _hoisted_22 = { class: "flex flex-col pt-12 items-center" }
const _hoisted_23 = { class: "mb-[20px]" }
const _hoisted_24 = { class: "flex flex-col pt-12" }
const _hoisted_25 = { class: "mb-8" }
const _hoisted_26 = { class: "flex flex-col pt-12" }
const _hoisted_27 = { class: "mb-8" }
const _hoisted_28 = { class: "flex flex-col pt-12" }
const _hoisted_29 = { class: "mb-8" }
const _hoisted_30 = { class: "flex flex-wrap sm:flex-nowrap lg:w-11/12 xl:w-10/12 h-2/3 text-white mx-auto justify-evenly items-start" }
const _hoisted_31 = { class: "flex flex-col ml-24 sm:ml-0 w-full sm:w-[22vw] lg:w-1/5" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "uppercase sm:text-sm lg:text-base 2xl:text-lg font-bold pt-20 2xl:pt-32 pb-5" }
const _hoisted_34 = { class: "flex flex-col ml-24 sm:ml-0 w-full sm:w-[22vw] lg:w-1/5" }
const _hoisted_35 = { class: "pt-20 2xl:pt-32" }
const _hoisted_36 = { class: "uppercase sm:text-sm lg:text-base 2xl:text-lg font-bold pb-5" }
const _hoisted_37 = {
  href: "https://gis.geosphere.at/tethys",
  class: "block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5"
}
const _hoisted_38 = {
  href: "https://gis.geosphere.at/tethys#info",
  class: "block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5"
}
const _hoisted_39 = { class: "list-none" }
const _hoisted_40 = { class: "list-none" }
const _hoisted_41 = { class: "list-none" }
const _hoisted_42 = { class: "flex flex-col ml-24 sm:ml-0 w-full sm:w-[22vw] lg:w-1/5 pb-12 sm:pb-0" }
const _hoisted_43 = { class: "pt-20 2xl:pt-32" }
const _hoisted_44 = { class: "uppercase sm:text-sm lg:text-base 2xl:text-lg font-bold pb-5" }
const _hoisted_45 = { class: "list-none py-1" }
const _hoisted_46 = {
  href: "https://gis.geosphere.at/tethys#faqs",
  class: "text-md text-gray-50 hover:text-tethys-green-dark transition-colors duration-200"
}
const _hoisted_47 = { class: "list-none py-1" }
const _hoisted_48 = { class: "list-none py-1" }
const _hoisted_49 = { class: "list-none py-1" }
const _hoisted_50 = { class: "w-full flex flex-wrap bg-geosphere-midnight-green h-1/3" }
const _hoisted_51 = { class: "flex flex-wrap sm:flex-nowrap lg:w-11/12 xl:w-10/12 text-white mx-auto justify-evenly items-start" }
const _hoisted_52 = { class: "flex flex-col sm:w-[33vw] lg:w-2/5" }
const _hoisted_53 = ["href"]
const _hoisted_54 = { class: "flex flex-col ml-24 sm:ml-0 w-full sm:pt-16 lg:pt-20 2xl:pt-24 sm:w-[22vw] lg:w-1/5" }
const _hoisted_55 = ["href"]
const _hoisted_56 = { class: "w-11/12 lg:w-10/12 flex text-white mx-auto justify-evenly items-start" }
const _hoisted_57 = { class: "flex flex-col sm:w-[66vw] lg:w-3/5" }
const _hoisted_58 = { class: "w-full text-left text-gray-400 text-xs 2xl:text-sm space-x-3 lg:space-x-5" }
const _hoisted_59 = ["href"]
const _hoisted_60 = ["href"]
const _hoisted_61 = ["href"]
const _hoisted_62 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaintenanceBanner = _resolveComponent("MaintenanceBanner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isServiceDown)
      ? (_openBlock(), _createBlock(_component_MaintenanceBanner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_1, [
      _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"flex items-center justify-end w-[60vw] sm:w-[20vw] lg:w-[18vw] 2xl:w-[16vw] space-x-1 xl:space-x-2 2xl:space-x-3 3xl:space-x-5\" data-v-bbce2f72><a class=\"\" href=\"/\" data-v-bbce2f72><img src=\"" + _imports_0 + "\" class=\"h-[60px] lg:h-[72px] xl:h-[72px] 2xl:h-20 3xl:h-24\" data-v-bbce2f72></a><span class=\"hidden md:block h-10 xl:h-11 2xl:h-14 3xl:h-16 w-0.5 bg-gray-400\" data-v-bbce2f72></span></div><div class=\"flex flex-col sm:w-[60vw] lg:w-[63vw] 2xl:w-[67vw] ml-1 md:pl-1 lg:pl-2 xl:pl-4 2xl:pl-5\" data-v-bbce2f72><span class=\"text-gray-500 text-xs sm:text-sm xl:text-lg 2xl:text-xl font-normal\" data-v-bbce2f72>Tethys Research Data Repository</span><span class=\"text-gray-400 text-xs xl:text-sm font-normal\" data-v-bbce2f72>Publisher for geoscientific research data</span></div>", 2)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          href: 'https://gis.geosphere.at/tethys',
          target: "_self",
          class: "flex items-center py-2 pr-2 text-gray-800 text-xs lg:text-sm hover:bg-gray-100 focus:outline-none rounded-md",
          title: _ctx.$t('tooltips.question_button')
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "fa-solid fa-circle-question" }, null, -1)
        ]), 8, _hoisted_3),
        _createElementVNode("a", {
          href: _ctx.portal,
          target: "_blank",
          class: "flex items-center py-1 px-2 text-gray-800 text-xs lg:text-sm hover:bg-gray-100 focus:outline-none rounded-md"
        }, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("login")), 1)
        ], 8, _hoisted_4),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "h-6 lg:h-8 w-[1px] lg:w-[2px] bg-gray-800" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "flex space-x-2 items-center py-1 px-2 text-gray-800 hover:bg-gray-100 focus:outline-none rounded-md",
            title: _ctx.$t('select_details_language'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dropdownOpen = !_ctx.dropdownOpen))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$i18n.locale.toUpperCase()), 1),
            _cache[4] || (_cache[4] = _createElementVNode("svg", {
              class: "h-4 text-gray-800",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 9l-7 7-7-7"
              })
            ], -1))
          ], 8, _hoisted_6),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: `locale-${locale}`
                }, [
                  (locale !== _ctx.$i18n.locale)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        class: _normalizeClass(["block px-4 py-2 text-gray-800 text-xs lg:text-sm hover:bg-gray-100 cursor-pointer", { 'font-bold text-tethys-green-dark': locale === _ctx.$i18n.locale }]),
                        onClick: _withModifiers(($event: any) => (_ctx.changeLocale(locale)), ["prevent"])
                      }, _toDisplayString(locale.toUpperCase()), 11, _hoisted_10))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ], 512), [
            [_vShow, _ctx.dropdownOpen]
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "md:hidden flex items-center px-1 py-5 border rounded text-gray-600 border-gray-200 hover:text-gray-800 hover:border-gray-400 hover:bg-gray-100 mr-2",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showMobilemenu && _ctx.showMobilemenu(...args))),
        "aria-label": "Toggle navigation"
      }, _cache[6] || (_cache[6] = [
        _createElementVNode("svg", {
          class: "h-6 w-6",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M4 6h16M4 12h16M4 18h16"
          })
        ], -1)
      ]))
    ]),
    (_ctx.active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, [
            _cache[9] || (_cache[9] = _createElementVNode("a", {
              href: 'https://gis.geosphere.at',
              target: "_self",
              class: "text-gray-800 text-lg"
            }, [
              _createElementVNode("i", { class: "fa-solid fa-circle-question" })
            ], -1)),
            _createElementVNode("a", {
              href: _ctx.portal,
              target: "_blank",
              class: "text-gray-800 text-sm"
            }, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("login")), 1)
            ], 8, _hoisted_13),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "flex py-2 px-2 items-center space-x-2 text-gray-800 hover:bg-gray-100 focus:outline-none",
                title: _ctx.$t('select_details_language'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dropdownOpen = !_ctx.dropdownOpen))
              }, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$i18n.locale.toUpperCase()), 1),
                _cache[8] || (_cache[8] = _createElementVNode("svg", {
                  class: "h-4 text-gray-800",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  })
                ], -1))
              ], 8, _hoisted_14),
              _withDirectives(_createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: `locale-${locale}`
                    }, [
                      (locale !== _ctx.$i18n.locale)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            class: _normalizeClass(["block px-4 py-2 text-gray-800 hover:bg-gray-100 cursor-pointer", { 'font-bold text-tethys-green-dark': locale === _ctx.$i18n.locale }]),
                            onClick: _withModifiers(($event: any) => (_ctx.changeLocale(locale)), ["prevent"])
                          }, _toDisplayString(locale.toUpperCase()), 11, _hoisted_18))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ], 512), [
                [_vShow, _ctx.dropdownOpen]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createElementVNode("footer", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('footer.certified_by')), 1),
            _cache[10] || (_cache[10] = _createElementVNode("a", {
              target: "_blank",
              href: "https://dataverse.nl/dataset.xhtml?persistentId=doi:10.34894/TKWVFL"
            }, [
              _createElementVNode("img", {
                src: _imports_1,
                class: "h-14 sm:h-12 2xl:h-16"
              })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('footer.registered_at')), 1),
            _cache[11] || (_cache[11] = _createElementVNode("a", {
              target: "_blank",
              href: "https://www.re3data.org/repository/r3d100013400"
            }, [
              _createElementVNode("img", {
                src: _imports_2,
                class: "h-8 sm:h-7 2xl:h-10"
              })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('footer.listed_in')), 1),
            _cache[12] || (_cache[12] = _createElementVNode("a", {
              target: "_blank",
              href: "https://www.base-search.net/Search/Results?q=coll:fttethysrdr&refid=dctablede"
            }, [
              _createElementVNode("img", {
                src: _imports_3,
                class: "h-9 sm:h-8 2xl:h-12"
              })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('footer.indexed_in')), 1),
            _cache[13] || (_cache[13] = _createElementVNode("a", {
              target: "_blank",
              href: "https://explore.openaire.eu/search/dataprovider?pid=r3d100013400"
            }, [
              _createElementVNode("img", {
                src: _imports_4,
                class: "h-8 sm:h-7 2xl:h-10"
              })
            ], -1))
          ])
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "flex w-4/6 pt-10 sm:pt-5 2xl:pt-0 mx-auto justify-evenly border-b-2 border-b-white border-opacity-20" }, null, -1)),
        _createElementVNode("div", _hoisted_30, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex flex-col sm:w-[33vw] lg:w-2/5" }, [
            _createElementVNode("span"),
            _createElementVNode("img", {
              src: _imports_5,
              class: "w-52 2xl:w-60 pt-8 2xl:pt-20 pb-1",
              alt: ""
            }),
            _createElementVNode("span", { class: "pl-16 2xl:pl-20 pb-2 ml-2" }, [
              _createTextVNode(" Tethys Research"),
              _createElementVNode("br"),
              _createTextVNode(" Data Repository ")
            ]),
            _createElementVNode("span", { class: "pl-16 2xl:pl-20 ml-2" }, [
              _createTextVNode(" Publisher for"),
              _createElementVNode("br"),
              _createTextVNode(" geoscientific research data ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('footer.contact')), 1),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "leading-relaxed pb-2" }, [
                _createTextVNode(" GeoSphere Austria"),
                _createElementVNode("br"),
                _createTextVNode(" Standort Neulinggasse 38,"),
                _createElementVNode("br"),
                _createTextVNode(" 1030 Wien"),
                _createElementVNode("br")
              ], -1)),
              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa-solid fa-phone text-base py-1 pr-1" }, null, -1)),
              _cache[16] || (_cache[16] = _createTextVNode(" +43 1 7125674")),
              _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa-solid fa-envelope text-base py-1 pr-1" }, null, -1)),
              _cache[19] || (_cache[19] = _createTextVNode(" repository@geosphere.at "))
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('footer.about_tethys')), 1),
              _createElementVNode("a", _hoisted_37, _toDisplayString(_ctx.$t('footer.about_tethys_links.news')), 1),
              _createElementVNode("a", _hoisted_38, _toDisplayString(_ctx.$t('footer.about_tethys_links.info')), 1),
              _createElementVNode("li", _hoisted_39, [
                _createVNode(_component_router_link, {
                  to: "/docs/HandbuchTethys.pdf",
                  target: "_blank",
                  class: "block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('footer.about_tethys_links.manual')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_40, [
                _createVNode(_component_router_link, {
                  to: "/docs/PreservationPlanTethys.pdf",
                  target: "_blank",
                  class: "block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('footer.about_tethys_links.preservation_plan')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_41, [
                _createVNode(_component_router_link, {
                  class: "block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5",
                  to: "/imprint"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('footer.about_tethys_links.imprint')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('footer.tools_support')), 1),
              _createElementVNode("li", _hoisted_45, [
                _createElementVNode("a", _hoisted_46, [
                  _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fa-regular fa-circle-question pr-2 text-base" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('footer.tools_support_links.faqs')), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_47, [
                _createVNode(_component_router_link, {
                  class: "text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-1",
                  to: "/oai"
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "fa-solid fa-circle-nodes pr-1 text-base" }, null, -1),
                    _createTextVNode(" OAI ")
                  ])),
                  _: 1,
                  __: [21]
                })
              ]),
              _createElementVNode("li", _hoisted_48, [
                _createVNode(_component_router_link, {
                  class: "text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-1",
                  to: "/sitelinks"
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createElementVNode("i", { class: "fa-solid fa-link pr-1 text-sm" }, null, -1),
                    _createTextVNode(" Sitelinks ")
                  ])),
                  _: 1,
                  __: [22]
                })
              ]),
              _createElementVNode("li", _hoisted_49, [
                _createVNode(_component_router_link, {
                  class: "text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-1",
                  to: "/terms-and-conditions"
                }, {
                  default: _withCtx(() => [
                    _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fa-solid fa-file-lines pl-1 pr-2 text-base" }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.$t('footer.tools_support_links.terms_conditions')), 1)
                  ]),
                  _: 1,
                  __: [23]
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("a", {
              href: `https://www.geosphere.at/${_ctx.$i18n.locale.toLowerCase()}`
            }, _cache[26] || (_cache[26] = [
              _createElementVNode("img", {
                src: _imports_6,
                class: "w-44 2xl:w-56 pt-10 pb-10 pl-2",
                alt: ""
              }, null, -1)
            ]), 8, _hoisted_53)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("a", {
              href: `https://www.geosphere.at/${_ctx.$i18n.locale.toLowerCase()}`,
              class: "text-xs lg:text-sm 2xl:text-base font-bold pb-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200"
            }, _cache[27] || (_cache[27] = [
              _createElementVNode("i", { class: "fa-solid fa-house pr-1" }, null, -1),
              _createTextVNode(" www.geosphere.at ")
            ]), 8, _hoisted_55),
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "" }, [
              _createElementVNode("div", { class: "leading-relaxed pb-2" }, [
                _createTextVNode(" GeoSphere Austria"),
                _createElementVNode("br"),
                _createTextVNode(" Hohe Warte 38,"),
                _createElementVNode("br"),
                _createTextVNode(" 1190 Wien"),
                _createElementVNode("br")
              ])
            ], -1))
          ]),
          _cache[29] || (_cache[29] = _createStaticVNode("<div class=\"flex flex-col sm:pt-14 lg:pt-20 2xl:pt-24 sm:w-[44vw] lg:w-2/5\" data-v-bbce2f72><div class=\"w-full grid grid-cols-2 lg:grid-cols-3 gap-x-4 py-7 sm:py-0\" data-v-bbce2f72><div class=\"flex items-center py-2 px-2\" data-v-bbce2f72><a target=\"_blank\" href=\"https://www.instagram.com/GeoSphere_AT\" rel=\"noreferrer\" class=\"flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200\" data-v-bbce2f72><img src=\"" + _imports_7 + "\" class=\"h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8\" data-v-bbce2f72><span data-v-bbce2f72>Instagram</span></a></div><div class=\"flex items-center py-2 px-2\" data-v-bbce2f72><a target=\"_blank\" rel=\"noreferrer\" href=\"https://x.com/GeoSphere_AT\" class=\"flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200\" data-v-bbce2f72><img src=\"" + _imports_8 + "\" class=\"h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8\" data-v-bbce2f72><span data-v-bbce2f72>X</span></a></div><div class=\"flex items-center py-2 px-2\" data-v-bbce2f72><a target=\"_blank\" rel=\"noreferrer\" href=\"https://www.youtube.com/@geosphereaustria2023\" class=\"flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200\" data-v-bbce2f72><img src=\"" + _imports_9 + "\" class=\"h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8\" data-v-bbce2f72><span data-v-bbce2f72>YouTube</span></a></div><div class=\"flex items-center py-2 px-2\" data-v-bbce2f72><a target=\"_blank\" rel=\"noreferrer\" href=\"https://www.facebook.com/GeoSphere.at\" class=\"flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200\" data-v-bbce2f72><img src=\"" + _imports_10 + "\" class=\"h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8\" data-v-bbce2f72><span data-v-bbce2f72>Facebook</span></a></div><div class=\"flex items-center py-2 px-2\" data-v-bbce2f72><a target=\"_blank\" rel=\"noreferrer\" href=\"https://at.linkedin.com/company/geosphereaustria\" class=\"flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200\" data-v-bbce2f72><img src=\"" + _imports_11 + "\" class=\"h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8\" data-v-bbce2f72><span data-v-bbce2f72>LinkedIn</span></a></div><div class=\"flex items-center py-2 px-2\" data-v-bbce2f72><a target=\"_blank\" rel=\"noreferrer\" href=\"https://www.flickr.com/photos/geosphere_austria\" class=\"flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200\" data-v-bbce2f72><img src=\"" + _imports_12 + "\" class=\"h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8\" data-v-bbce2f72><span data-v-bbce2f72>Flickr</span></a></div></div></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_56, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "flex flex-col sm:w-[33vw] lg:w-2/5" }, null, -1)),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("a", {
                href: _ctx.$t('footer.urls.impressum'),
                class: "text-gray-50 hover:text-geosphere-lemon transition-colors duration-200"
              }, _toDisplayString(_ctx.$t('footer.legal_links.impressum')), 9, _hoisted_59),
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "border-r-2 border-r-geosphere-lemon" }, null, -1)),
              _createElementVNode("a", {
                href: _ctx.$t('footer.urls.datenschutz'),
                class: "text-gray-50 hover:text-geosphere-lemon transition-colors duration-200"
              }, _toDisplayString(_ctx.$t('footer.legal_links.datenschutz')), 9, _hoisted_60),
              _cache[31] || (_cache[31] = _createElementVNode("span", { class: "border-r-2 border-r-geosphere-lemon" }, null, -1)),
              _createElementVNode("a", {
                href: _ctx.$t('footer.urls.legal'),
                class: "text-gray-50 hover:text-geosphere-lemon transition-colors duration-200"
              }, _toDisplayString(_ctx.$t('footer.legal_links.legal')), 9, _hoisted_61),
              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "border-r-2 border-r-geosphere-lemon" }, null, -1)),
              _createElementVNode("a", {
                href: _ctx.$t('footer.urls.barrierefreiheit'),
                class: "text-gray-50 hover:text-geosphere-lemon transition-colors duration-200"
              }, _toDisplayString(_ctx.$t('footer.legal_links.barrierefreiheit')), 9, _hoisted_62)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}